import React from 'react';
import ContentProduct from './ContentProducts';
import _ from 'lodash';
class Content extends React.Component {
    addToCart = (product)=>{
        let {cart} = this.props,
        idx = -1;
        if(cart && cart.length)
        {
            idx = cart.findIndex((item)=>parseInt(item.id) === parseInt(product.id));
            idx > -1 && 
                (cart[idx].cnt += 1);
        }
        (!cart.length || idx === -1) && cart.push({id:product.id,pcd:product.pcd,title:product.title,
        price: product.meta.price_after_discount,
        price_origin:parseFloat(product.meta.price),
        category:product.meta.category,
        image: product.image,
        link:product.link,cnt:1});
        this.props.addToCart(cart);
    }
    handleChangeCate=(e,item)=>{
        e.preventDefault();
        this.props.handleChangeCate(item);
    }
    render(){
        let {products, configDeal, menuCates, cate, event} = this.props;
        configDeal = configDeal ? configDeal.config_values : null;
        configDeal = configDeal && JSON.parse(configDeal);
        let catesView = [
            <a key='all' onClick={(e)=>this.handleChangeCate(e,'all')} href={event.link} className={`load-deal btn mr-2 mr-md-3 text-sm text-dark ${!cate?'active':''}`}>Tất cả</a>
        ];
        if(menuCates)
        {
            let menuCatesView = menuCates.map((item,idx)=>{
                return (
                    <a key={idx} onClick={(e)=>this.handleChangeCate(e,item)}
                    className={`load-deal btn mr-2 mr-md-3 text-sm text-dark ${cate && item.id===cate.id?'active':''}`} 
                    href={item.url}>{item.title}</a>
                )
            })
            catesView = [...catesView,...menuCatesView];
        }
        return (
            <div className="container-fluid bg-white">
                <div className="row bg-light">
                    
                    <div className="container">
                        {configDeal && typeof configDeal.banner !=='undefined' ? 
                        <div className="row banner mb-4">
                            <a href={event.link}><img src={configDeal.banner} alt={event.name} className="img-fluid" /></a>
                            
                        </div>
                        :null}
                        <div className="row">
                            <div className="col-12">
                                <div className="row bg-white p-3">
                                    <div className="w-100 tab-menu">
                                        {catesView}
                                    </div>
                                    <div className="product-list w-100">
                                        <ContentProduct addToCart={this.addToCart} handleChangeCate={this.handleChangeCate} products={products} />
                                    </div>
                                </div>
                            </div>
                            {/* end product */}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Content;